import { MeiliSearch } from 'meilisearch';
import MeilisearchInput from '@/js/components/Forms/Inputs/MeilisearchInput.js';

export default class SearchWithAutocomplete {
  rootElements = [];

  meilisearchClient = undefined;

  lastSearchResponse = undefined;

  init() {
    if (
      !window.meilisearch?.host ||
      !window.meilisearch?.searchKey ||
      !window.meilisearch?.federationMultiSearch ||
      !window.meilisearch?.federationMultiSearch?.postTypeIndexesQueryParams
    ) {
      return;
    }

    this.meilisearchClient = new MeiliSearch({
      host: window.meilisearch.host,
      apiKey: window.meilisearch.searchKey,
    });

    this.rootElements = Array.from(
      document.querySelectorAll('.search-form-with-autocomplete')
    );

    for (let rootElement of this.rootElements) {
      this.initSearchForm(rootElement);
    }
  }

  initSearchForm(rootElement) {
    const resultList = rootElement.querySelector('ul');

    const meilisearchInput = new MeilisearchInput(rootElement, {
      wrapperElement: rootElement.querySelector('label.meilisearch-input'),
      inputElement: rootElement.querySelector('input[type="search"]'),
      resetButtonElement: rootElement.querySelector('button[type="reset"]'),
      onInput: (value) => {
        if (meilisearchInput.isFilled) {
          this.initNewSearch(rootElement, value, resultList);
        } else {
          this.setListMessage(
            resultList,
            window.meilisearch?.locales?.fr_FR?.initSearch || ''
          );
        }
      },
      onReset: () => {
        this.emptyList(resultList);
        this.setListMessage(
          resultList,
          window.meilisearch?.locales?.fr_FR?.initSearch || ''
        );
      },
    });

    if (!meilisearchInput.inputElement.value.length) {
      this.setListMessage(
        resultList,
        window.meilisearch?.locales?.fr_FR?.initSearch || ''
      );
    }
  }

  initNewSearch(rootElement, queryValue, resultList) {
    if (!queryValue.length) {
      return;
    }

    rootElement.classList.remove('meilisearch-is-first-loading');

    this.setIsLoading(rootElement, true);

    this.lastSearchResponse = undefined;

    this.meilisearchClient
      .multiSearch(this.queryStringToMultiParams(queryValue))
      .then((response) => {
        this.lastSearchResponse = response;

        this.setResultsList(resultList, response.hits || []);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
      })
      .finally(() => {
        this.setIsLoading(rootElement, false);
      });
  }

  queryStringToMultiParams(q) {
    // const queries = [];
    const queries = [];

    for (let index of Object.keys(
      window.meilisearch.federationMultiSearch.postTypeIndexesQueryParams
    )) {
      queries[index] = {};

      queries.push({
        ...window.meilisearch.federationMultiSearch.postTypeIndexesQueryParams[
          index
        ],
        attributesToSearchOn: ['postTitle'],
        q,
      });
    }

    return {
      federation: {
        limit: 10,
      },
      queries,
    };
  }

  setIsLoading(rootElement, isLoading) {
    rootElement.classList.toggle(
      'search-form-with-autocomplete--is-loading',
      isLoading
    );
  }

  setResultsList(resultList, resultHits) {
    this.emptyList(resultList);

    if (!resultHits.length) {
      this.setListMessage(
        resultList,
        window.meilisearch?.locales?.fr_FR?.noResultsFound || ''
      );

      return;
    }

    for (let hit of resultHits) {
      resultList.insertAdjacentHTML(
        'beforeend',
        `<li class="search-form-with-autocomplete__result-item search-form-with-autocomplete__result-item--${hit.postType || 'page'}">
          <a class="search-form-with-autocomplete__result-item-link" href="${hit.postPermalink || '#'}">
            <span class="search-form-with-autocomplete__result-item-icon" aria-hidden="true"></span>
            <span class="search-form-with-autocomplete__result-item-label">${hit.postTitle || ''}</span>
          </a>
        </li>`
      );
    }
  }

  setListMessage(resultList, message) {
    this.emptyList(resultList);

    resultList.insertAdjacentHTML(
      'beforeend',
      `<li class="search-form-with-autocomplete__message-item">
        <span class="search-form-with-autocomplete__message-item-label">${message}</span>
      </li>`
    );
  }

  emptyList(resultList) {
    resultList.innerHTML = '';
  }
}
